<template>
  <div class="my-4 w-full flex justify-center">
    <Button :disabled="allLoaded" :loading="loading" @click="handler">
      Load More...
    </Button>
  </div>
</template>

<script>
export default {
  name: "InfiniteLoader",
  components: {},
  mixins: [],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    schema: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  computed: {
    allLoaded() {
      return this.pagination.next_page > this.pagination.last_page;
    },
    list() {
      return this.$store.getters[this.schema.getter];
    },
    pagination() {
      return this.$store.getters[this.schema.pagination];
    }
  },
  data() {
    return {
      loading: this.value
    };
  },
  methods: {
    async handler() {
      this.loading = true;
      this.$emit("input", this.loading);

      try {
        await this.$store.dispatch(this.schema.action, this.pagination);
      } catch (_) {
        this.$notify({
          type: "error",
          group: "foo",
          text: "Probably the ip to the server is wrong."
        });
      }

      this.loading = false;
      this.$emit("input", this.loading);
    }
  },
  async created() {
    await this.$store.commit(this.schema.clean);
    this.handler();
  }
};
</script>

<style></style>
